import React from 'react';
import { ResourcesComponent } from '../../components';

export const ResourcesContainer: React.FC<{
	setPage: (page: number) => void;
}> = ({ setPage }): JSX.Element => <ResourcesComponent setPage={setPage} />;
